"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.username.placeholder': 'Inserisci nome utente',
};
